export const TestIds = {
  section: 'section-container',
} as const;

export const corvidName = '$w.Section';

export const TranslationKeys = {
  ariaLabel: 'TextEffects_MediaButton_AriaLabel',
  namespace: 'ariaLabels',
};
